import React, { useMemo } from "react";
import TroopItemsDialog from "../../../components/TroopItemsDialog";
import { useAppDispatch } from "../../../hooks/reduxHook";
import { fetchPlayerTroop } from "../../../redux/pages/barracks/barracksActions";
import { useBarracksUIContext } from "../BarracksContext";
import ConfirmDialog from "./ConfirmDialog";
import InstantHealDialog from "./InstantHealDialog";
import MergeDialog from "./MergeDialog";
import SellDialog from "./SellDialog";
import TrainDialog from "./TrainDialog";
import UpgradeDialog from "./UpgradeDialog";

const BarracksDialogs = () => {
  const dispatch = useAppDispatch();

  const barracksContext = useBarracksUIContext();
  const barracksUIProps = useMemo(() => {
    return {
      troopItemsDialog: barracksContext?.troopItemsDialog,
      setTroopItemsDialog: barracksContext?.setTroopItemsDialog,
    };
  }, [barracksContext?.troopItemsDialog, barracksContext?.setTroopItemsDialog]);

  const plyerTroopFetch = () => {
    dispatch(fetchPlayerTroop(50));
  };

  return (
    <>
      <TrainDialog />
      <ConfirmDialog />
      <SellDialog />
      <MergeDialog />
      <UpgradeDialog />
      <InstantHealDialog />

      {barracksUIProps?.troopItemsDialog?.open && (
        <TroopItemsDialog
          onRefresh={() => {
            plyerTroopFetch();
          }}
          open={barracksUIProps?.troopItemsDialog?.open}
          troop={barracksUIProps?.troopItemsDialog?.troop}
          onClose={() => {
            barracksUIProps?.setTroopItemsDialog?.((prev) => ({
              ...prev,
              open: false,
            }));
            plyerTroopFetch();
          }}
        />
      )}
    </>
  );
};

export default BarracksDialogs;
